<svg
  width="30"
  height="30"
  viewBox="0 0 30 30"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M0 5C0 2.23858 2.23858 0 5 0H25C27.7614 0 30 2.23858 30 5V25C30 27.7614 27.7614 30 25 30H5C2.23858 30 0 27.7614 0 25V5Z"
    fill="#1C1C20"
  />
  <path
    d="M10.5 22.1C10.0833 22.1 9.72917 21.9542 9.4375 21.6625C9.14583 21.3708 9 21.0167 9 20.6V8.4H8V7.7H11.7V7H17.7V7.7H21.4V8.4H20.4V20.6C20.4 21.0333 20.2583 21.3917 19.975 21.675C19.6917 21.9583 19.3333 22.1 18.9 22.1H10.5ZM19.7 8.4H9.7V20.6C9.7 20.8333 9.775 21.025 9.925 21.175C10.075 21.325 10.2667 21.4 10.5 21.4H18.9C19.1 21.4 19.2833 21.3167 19.45 21.15C19.6167 20.9833 19.7 20.8 19.7 20.6V8.4ZM12.75 19.4H13.45V10.4H12.75V19.4ZM15.95 19.4H16.65V10.4H15.95V19.4Z"
    fill="#F9FBFF"
  />
</svg>
